var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('v-row',[_c('v-col',[_c('h1',{staticClass:"text-h5"},[_vm._v(" Edit Report ")])])],1)],1),_c('v-container',[_c('report',{attrs:{"vertical-id":_vm.$route.params.verticalId,"account-type":_vm.$route.params.accountType,"path":_vm.$route.params.path}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }